import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import PageLoader from "../../../../components/PageLoader";
import { settings } from "../../../../redux/settings/actions";
import UploadCommonModal from "../../../../models/upload-common-modal";
import { selectCurrent } from "../../../../redux/settings/selectors";
import { toast } from "react-toastify";
import Table from "../../../../common/components/table-manager/v1.1/table";
import { globalDbnTaxonomySubDomainAttributesCategoryMappings } from "../../../../redux/global-dbn-taxonomy-sub-domain-attributes-category-mappings/action";
import { selectGlobalDbnTaxonomySubDomainAttributesCategoryMappingsCreatedItem, selectGlobalDbnTaxonomySubDomainAttributesCategoryMappingsDeletedItem, selectGlobalDbnTaxonomySubDomainAttributesCategoryMappingsListItems, selectGlobalDbnTaxonomySubDomainAttributesCategoryMappingsUpdatedItem } from "../../../../redux/global-dbn-taxonomy-sub-domain-attributes-category-mappings/selector";
import { selectListItems } from "../../../../redux/library/selector";

const GlobalDbnTaxonomySubDomainAttributeCategoryMappings = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const libraryData = useSelector(selectListItems)
  const { getUploadModal } = useAppSelector(selectCurrent)
  const listGlobalDbnTaxonomySubDomainAttributesData = useSelector(selectGlobalDbnTaxonomySubDomainAttributesCategoryMappingsListItems)
  const createGlobalDbnTaxonomySubDomainAttributesData = useSelector(selectGlobalDbnTaxonomySubDomainAttributesCategoryMappingsCreatedItem)
  const updateGlobalDbnTaxonomySubDomainAttributesData = useSelector(selectGlobalDbnTaxonomySubDomainAttributesCategoryMappingsUpdatedItem)
  const deleteGlobalDbnTaxonomySubDomainAttributesData = useSelector(selectGlobalDbnTaxonomySubDomainAttributesCategoryMappingsDeletedItem)
  const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'CategoryName', headerName: 'Category', searchField: 'CategoryName', sortable: true, filter: true, filterType: 'text', },
      { field: 'DBNSubDomainAttributeName', headerName: 'DBN Sub-Domain Attribute Name', searchField: 'DBNSubDomainAttributeName', sortable: true, filter: true, filterType: 'text', },
      { field: 'DomainName', headerName: 'Domain', searchField: 'DomainName', sortable: true, filter: true, filterType: 'text', },
      {
        field: 'ConditionId',
        headerName: 'Condition',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.AttributeCondition },
        searchField: 'ConditionId', 
        sortable: true,
        filter: true
      },
      { field: 'IsAppliedToB2C', headerName: 'Is Applied To B2C', searchField: 'IsAppliedToB2C', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
      { field: 'IsAppliedToB2B', headerName: 'Is Applied To B2B', searchField: 'IsAppliedToB2B', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
      { field: 'IsAppliedToBoth', headerName: 'Is Applied To Both', searchField: 'IsAppliedToBoth', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
    ]);
  }

  const fetchGlobalDbnTaxonomySubDomainAttributes = async () => {
    await dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.resetAction({ actionType: 'list' }))
    await dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attribute-and-category-mappings/fetch`,
      entity: 'GlobalDbnTaxonomySubDomainAttributeCategoryMappings',
      jsonData:
      {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleAdd = () => {
    // navigate(`${0}`)
    navigate('/dbn/sub-domain-attributes-category-mappings/manage')
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.DBNSubDomainAttributeId}`)
  }

  const handleSearch = async (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column || data?.searchCriteriaList,
        FieldText: data?.column || data?.searchCriteriaList,
        FieldType: 'text',
        FilterOperatorId: data?.filterOperatorId || 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    await dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.resetAction({ actionType: 'list' }))
    await dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attribute-and-category-mappings/fetch`,
      entity: 'globalDbnTaxonomySubDomainAttributes',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "DBNSubDomainAttributeId",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleDownloadTemplate = () => {
    const fileUrl = require('../../../../assets/data/attribute_mapping_template.csv');
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "attribute_mapping_template.csv"); // Optional: Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Manage Mappings</title>
          <path d="M21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5Z" stroke="currentColor" stroke-width="1.5" />
          <path d="M3 6.5C3 4.85008 3 4.02513 3.51256 3.51256C4.02513 3 4.85008 3 6.5 3C8.14992 3 8.97487 3 9.48744 3.51256C10 4.02513 10 4.85008 10 6.5C10 8.14992 10 8.97487 9.48744 9.48744C8.97487 10 8.14992 10 6.5 10C4.85008 10 4.02513 10 3.51256 9.48744C3 8.97487 3 8.14992 3 6.5Z" stroke="currentColor" stroke-width="1.5" />
          <path d="M3 17.5C3 15.8501 3 15.0251 3.51256 14.5126C4.02513 14 4.85008 14 6.5 14C8.14992 14 8.97487 14 9.48744 14.5126C10 15.0251 10 15.8501 10 17.5C10 19.1499 10 19.9749 9.48744 20.4874C8.97487 21 8.14992 21 6.5 21C4.85008 21 4.02513 21 3.51256 20.4874C3 19.9749 3 19.1499 3 17.5Z" stroke="currentColor" stroke-width="1.5" />
          <path d="M14 17.5C14 15.8501 14 15.0251 14.5126 14.5126C15.0251 14 15.8501 14 17.5 14C19.1499 14 19.9749 14 20.4874 14.5126C21 15.0251 21 15.8501 21 17.5C21 19.1499 21 19.9749 20.4874 20.4874C19.9749 21 19.1499 21 17.5 21C15.8501 21 15.0251 21 14.5126 20.4874C14 19.9749 14 19.1499 14 17.5Z" stroke="currentColor" stroke-width="1.5" />
          <path d="M17.5 10V14M14 17.5H10M10 6.5H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Manage Mappings',
      callback: () => handleAdd(),
    },
    // {
    //   name: 'Import Attributes',
    //   callback: () => handleImportAttributesClick(),
    // },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Import Mappings</title>
          <path d="M3.00012 14L3.23397 14.6626C4.14412 17.2413 4.5992 18.5307 5.63754 19.2654C6.67588 20 8.04322 20 10.7779 20H13.2224C15.957 20 17.3244 20 18.3627 19.2654C19.401 18.5307 19.8561 17.2413 20.7663 14.6626L21.0001 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M12.0001 14V4M12.0001 14C11.2999 14 9.99165 12.0057 9.50012 11.5M12.0001 14C12.7003 14 14.0086 12.0057 14.5001 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Import Mappings',
      callback: () => handleImportAttributesMappingClick(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none">
          <title>Download Template</title>
          <path d="M4 7C4.58984 7.60684 6.15973 10 7 10C7.84027 10 9.41016 7.60684 10 7M7 9L7 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M4 13L4 14.5442C4 17.7892 4 19.4117 4.88607 20.5107C5.06508 20.7327 5.26731 20.9349 5.48933 21.1139C6.58831 22 8.21082 22 11.4558 22C12.1614 22 12.5141 22 12.8372 21.886C12.9044 21.8623 12.9702 21.835 13.0345 21.8043C13.3436 21.6564 13.593 21.407 14.0919 20.9081L18.8284 16.1716C19.4065 15.5935 19.6955 15.3045 19.8478 14.9369C20 14.5694 20 14.1606 20 13.3431V10C20 6.22876 20 4.34315 18.8284 3.17157C17.6569 2 15.7712 2 12 2M13 21.5V21C13 18.1716 13 16.7574 13.8787 15.8787C14.7574 15 16.1716 15 19 15H19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Download',
      callback: () => handleDownloadTemplate(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    fetchGlobalDbnTaxonomySubDomainAttributes();
  }

  const handleImportAttributesMappingClick = () => {
    dispatch(settings.set({ getUploadModal: 'open' }))
  };

  const handleDelete = async (data: any) => {
    await dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.resetAction({ actionType: 'delete' }))
    await dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attribute-and-category-mappings/delete`,
      entity: 'globalDbnTaxonomySubDomainAttributes',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.DBNSubDomainAttributeId
          }
        ]
      }
    })).then(() => {
      fetchGlobalDbnTaxonomySubDomainAttributes();
    });
  }

  const handleImportMappingsClick = async (data: any) => {
    const frmData = new FormData();
    frmData.append(
      'formFile',
      data
    );
    await dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.resetAction({ actionType: 'uploadCreate' }))
    await dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.uploadCreate({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbn-sub-domain-attribute-and-category-mappings/upload-dbn-sub-domain-attribute-and-category-mapping`,
      entity: 'createSubDomainAttributes',
      jsonData:
        frmData
    })).then(() => {
      handleUploadClose()
    }).then(() => {
      fetchGlobalDbnTaxonomySubDomainAttributes();
    })
  };

  const handleUploadClose = () => {
    dispatch(settings.set({ getUploadModal: 'close' }))
  }

  useEffect(() => {
    const searchCriteria: any = listGlobalDbnTaxonomySubDomainAttributesData?.result?.items
      ?.filter((item: any) => item?.Message?.SpecificationAttributeName) // Filter out items with falsy SpecificationAttributeName
      ?.map((item: any) => ({
        FieldName: item.Message.SpecificationAttributeName,
      }));
    setSearchCriteriaList(searchCriteria)
  }, [listGlobalDbnTaxonomySubDomainAttributesData]);

  useEffect(() => {
    if (createGlobalDbnTaxonomySubDomainAttributesData?.isSuccess) {
      dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.resetAction({ actionType: 'create' }))
      toast.info('Domain created successfully.')
    }
  }, [createGlobalDbnTaxonomySubDomainAttributesData]);

  useEffect(() => {
    if (updateGlobalDbnTaxonomySubDomainAttributesData?.isSuccess) {
      dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.resetAction({ actionType: 'update' }))
      toast.info('Domain updated successfully.')
    }
  }, [updateGlobalDbnTaxonomySubDomainAttributesData]);

  useEffect(() => {
    if (deleteGlobalDbnTaxonomySubDomainAttributesData?.isSuccess) {
      dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.resetAction({ actionType: 'delete' }))
      toast.info('Domain deleted successfully.')
    }
  }, [deleteGlobalDbnTaxonomySubDomainAttributesData]);

  useEffect(() => {
    createColumnDefs()
    fetchGlobalDbnTaxonomySubDomainAttributes()
    dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.resetAction({ actionType: 'create' }))
    dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.resetAction({ actionType: 'uploadCreate' }))
    dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.resetAction({ actionType: 'update' }))
    dispatch(globalDbnTaxonomySubDomainAttributesCategoryMappings.resetAction({ actionType: 'delete' }))
  }, [pageData, pageSize])

  return (
    <>
      {getUploadModal == 'open' && <UploadCommonModal title='Import Category - Attributes Mapping' onSubmit={handleImportMappingsClick} handleClose={handleUploadClose} />}
      {listGlobalDbnTaxonomySubDomainAttributesData?.isLoading ||
        createGlobalDbnTaxonomySubDomainAttributesData?.isLoading ||
        updateGlobalDbnTaxonomySubDomainAttributesData?.isLoading ||
        deleteGlobalDbnTaxonomySubDomainAttributesData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={listGlobalDbnTaxonomySubDomainAttributesData?.result?.items}
          enableFilter={true}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listGlobalDbnTaxonomySubDomainAttributesData?.result?.pagination}
          onSearch={handleSearch}
          searchCriteriaList={searchCriteriaList}
          // onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          headingName="Sub-Domain Attributes Category Mappings"
        />
      }
    </>
  );
};

export default GlobalDbnTaxonomySubDomainAttributeCategoryMappings;


